import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataCard,
  setDataColor,
  setDataColorAll,
  setDataSidebar,
  setDataSidebarAll,
  setDataTheme,
  setDataTopbarAll,
  setDataTopBarColorAll,
  setLoader,
  setTopBarColor,
} from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";

const ThemeSettings = () => {
  const dispatch = useDispatch();
  
  // Theme selectors
  const dataCard = useSelector((state: any) => state.themeSetting.dataCard);
  const dataTopBar = useSelector((state: any) => state.themeSetting.dataTopBar);
  const dataTopBarColor = useSelector((state: any) => state.themeSetting.dataTopBarColor);
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataSidebar = useSelector((state: any) => state.themeSetting.dataSidebar);
  // Background selectors removed - not used in simplified theme
  const dataColor = useSelector((state: any) => state.themeSetting.dataColor);
  const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);
  const dataSidebarAll = useSelector((state: any) => state.themeSetting.dataSidebarAll);
  const dataColorAll = useSelector((state: any) => state.themeSetting.dataColorAll);
  const dataTopBarColorAll = useSelector((state: any) => state.themeSetting.dataTopBarColorAll);
  const dataTopbarAll = useSelector((state: any) => state.themeSetting.dataTopbarAll);

  // Color state
  const [colorRgb, setColorRgb] = useState(`rgb(${dataSidebarAll})`);
  const [colorRgb2, setColorRgb2] = useState(`rgb(${dataTopbarAll})`);
  const [colorRgb3, setColorRgb3] = useState(`rgb(${dataTopBarColorAll})`);
  const [colorRgb4, setColorRgb4] = useState(`rgb(${dataColorAll})`);

  // Extract RGB values
  const rgbString = colorRgb.replace(/rgb\(|\)/g, "").trim();
  const rgbString2 = colorRgb2.replace(/rgb\(|\)/g, "").trim();
  const rgbString3 = colorRgb3.replace(/rgb\(|\)/g, "").trim();
  const rgbString4 = colorRgb4.replace(/rgb\(|\)/g, "").trim();

  // Update color values
  useEffect(() => {
    dispatch(setDataSidebarAll(rgbString.replace(/rgb\(|\)/g, "").trim()));
    dispatch(setDataTopbarAll(rgbString2.replace(/rgb\(|\)/g, "").trim()));
    dispatch(setDataTopBarColorAll(rgbString3.replace(/rgb\(|\)/g, "").trim()));
    dispatch(setDataColorAll(rgbString4.replace(/rgb\(|\)/g, "").trim()));
  }, [dispatch, rgbString, rgbString2, rgbString3, rgbString4]);

  const handleBorderChange = (layout: string) => {
    dispatch(setDataCard(layout));
  };
  
  const handleTopBarColorChange = (color: string) => {
    dispatch(setTopBarColor(color));
  };
  
  const handleDataThemeChange = (theme: string) => {
    dispatch(setDataTheme(theme));
  };
  
  const handleDataSidebarChange = (theme: string) => {
    dispatch(setDataSidebar(theme));
  };
  
  const handleDataColorChange = (color: string) => {
    dispatch(setDataColor(color));
  };
  
  const handleDataLoaderChange = (loader: string) => {
    dispatch(setLoader(loader));
  };

  useEffect(() => {
    // Set fixed horizontal layout
    document.documentElement.setAttribute("data-layout", "horizontal-single");
    document.documentElement.setAttribute("data-card", dataCard);
    document.documentElement.setAttribute("data-sidebar", dataSidebar);
    document.documentElement.setAttribute("data-theme", dataTheme === "dark_data_theme" ? "dark" : "");
    document.documentElement.setAttribute("data-topbar", dataTopBar);
    document.documentElement.setAttribute("data-topbarcolor", dataTopBarColor);
    document.documentElement.setAttribute("data-color", dataColor);
    document.documentElement.setAttribute("data-loader", dataLoader);
    // Background attributes removed - not used in simplified theme
    setColorRgb(`rgb(${dataSidebarAll})`);
    setColorRgb2(`rgb(${dataTopbarAll})`);
    setColorRgb3(`rgb(${dataTopBarColorAll})`);
    setColorRgb4(`rgb(${dataColorAll})`);
  }, [dataSidebar, dataSidebarAll, dataTheme, dataTopBarColor, dataTopBar, dataColor, dataLoader, dataColorAll, dataTopBarColorAll, dataTopbarAll, dataCard]);

  return (
    <>
    </>
  );
};

export default ThemeSettings;